export function capitalize(value: string): string {
  if (!value) return ''
  const singleWords = value?.split(' ')
  return singleWords
    ?.map(word => {
      if (word?.length === 2) return word?.toLowerCase()
      return word[0]?.toUpperCase() + word?.substring(1)?.toLowerCase()
    })
    .join(' ')
}
